/*
 * Feature keys should be added to this file like:
 *
 * ```
 * const featureKeys = Object.freeze({
 *   FEATURE_FLAG_NAME: 'domain.subdomain.feature',
 * });
 * ```
 */

const featureKeys = Object.freeze({
  /**
   * When true in LD, flags use LaunchDarkly only; when false, Harness overlays boolean flags.
   */
  SERVE_FROM_LAUNCHDARKLY: 'serve-from-launchDarkly',
  AUTHORING_PREVENT_CONFIG_ASSET_RESOLVE: 'authoring-brnt-15109',
  LEARNSPACE_DYNAMIC_CALLS_NON_BLOCKING: 'authoring-brnt-15383',
  LEARNSPACE_SOLUTION_1_POC: 'learnspace-brnt-15961',
  LEARNSPACE_POC_V2: 'learnspace-performance-2',
  LEARNSPACE_RTM_SOLUTION_1_POC: 'learnspace-brnt-16436',
  BALT_1036_LEARNSPACE_SYSTEM_DOWN_MESSAGE: 'BALT-1036_Learnspace_System_Down_Message',
});

export default featureKeys;
